import React from "react"
import Paper from "material-ui/Paper"
import strings from "../../../localization/strings"
import IconButton from "material-ui/IconButton"
import FontIcon from "material-ui/FontIcon"
import PayrollTimeByHierarchyTable from "./PayrollTimeByHierarchyTable"
import { CircularProgress } from "material-ui"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import AccountStore from "../../../stores/AccountStore"
import { IPayrollTime, IPayrollTimeHierarchy, IPayrollTimeHierarchyEmployee } from "../../../models"
import FlagCheckred from "../../../../assets/icons/flag-checkered"
import { hasPermission } from "../../../helpers/permissionHelper"
import * as payrollHelper from "../../../helpers/payrollHelper"
import AppStateStore from "../../../stores/AppStateStore"

interface IProps {
    payrollData: IPayrollTime
    loading: boolean
    selectedPayrollHierarchies: IPayrollTimeHierarchy[]
    selectedEmployees: IPayrollTimeHierarchyEmployee[]
    onDownload(): void
    onDownloadTimeReport(): void
    onEmployeeLock(): void
    onEmployeeUnLock(): void
    onLock(): void
    onUnLock(): void
    onClose(): void
    onExport(): void
    showTimecardPopup(employeeId: string, referenceDate: string): void
    handleSelectPayrollHierarchy(selectedPayrollHierarchies: IPayrollTimeHierarchy[]): void
    handleSelectEmployee(selectedEmployees: IPayrollTimeHierarchyEmployee[], unselectedEmployees: IPayrollTimeHierarchyEmployee[]): void
    reloadTimeCard: () => void
}

export default class PayrollTimeByHierarchy extends React.Component<IProps, any> {
    private PayrollTimeByHierarchyTable = null
    render() {
        const payrollTimeHierarchies = this.props.payrollData && this.props.payrollData.PayrollTimeHierarchies
        let lockPayrollPermission = hasPermission(AuthenticationStore.Permissions.Payroll.LockPayroll)
        let closePayrollPermission = hasPermission(AuthenticationStore.Permissions.Payroll.ClosePayroll)
        let exportPayrollPermission = hasPermission(AuthenticationStore.Permissions.Payroll.ExportPayroll)
        if (AccountStore.getExpensesEnabled() && AccountStore.getExpenseIsPayrollTime()) {
            lockPayrollPermission = lockPayrollPermission && hasPermission(AuthenticationStore.Permissions.Expense.LockPayrollExpense)
            closePayrollPermission = closePayrollPermission && hasPermission(AuthenticationStore.Permissions.Expense.ClosePayrollExpense)
            exportPayrollPermission = exportPayrollPermission && hasPermission(AuthenticationStore.Permissions.Expense.ExportPayrollExpense)
        }
        if (!AuthenticationStore.checkSupervisorAllowPayrollActions()) {
            lockPayrollPermission = false
            closePayrollPermission = false
        }

        const renderElem = (
            <div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div style={{ fontSize: 16, fontWeight: 600, }}>{strings.Time_Summary}</div>
                    {!this.props.loading &&
                        payrollTimeHierarchies.length > 0 &&
                        <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                            {AccountStore.getEnableEmployeeLock() && lockPayrollPermission &&
                                this.props.selectedPayrollHierarchies.filter((item) => !item.EmpLockedData.IsLocked).length > 0 &&
                                <IconButton data-intercom-target={"menu-Payroll-Btn-EmployeeLockTimePayrollHierarchy"} tooltip={strings.Employee_Lock} onTouchTap={this.props.onEmployeeLock}>
                                    <FontIcon className="fa fa-user-lock" style={{ fontSize: 20 }} />
                                </IconButton>
                            }
                            {AccountStore.getEnableEmployeeLock() && lockPayrollPermission &&
                                this.props.selectedPayrollHierarchies.filter((item) => item.EmpLockedData.IsLocked).length > 0 &&
                                this.props.selectedPayrollHierarchies.filter(item => item.ClosedData.IsClosed).length === 0 &&
                                <IconButton data-intercom-target={"menu-Payroll-Btn-EmployeeUnLockTimePayrollHierarchy"} tooltip={strings.Employee_Unlock} onTouchTap={this.props.onEmployeeUnLock}>
                                    <FontIcon className="fa fa-user-unlock" style={{ fontSize: 20 }} />
                                </IconButton>
                            }
                            {lockPayrollPermission &&
                                (
                                    this.props.selectedPayrollHierarchies.filter((item) => !item.LockedData.IsLocked).length > 0 ||
                                    (
                                        this.props.selectedPayrollHierarchies.length === 0 &&
                                        this.props.selectedEmployees.filter(emp =>
                                            this.props.payrollData.PayrollTimeHierarchies.find(hierarchy =>
                                                hierarchy.LockedData.LockedObjData.find(i => i.LockedObjId === emp.EmployeeId))
                                        ).length !== this.props.selectedEmployees.length
                                    )
                                ) &&
                                <IconButton data-intercom-target={"menu-Payroll-Btn-LockTimePayrollHierarchy"} tooltip={strings.Lock} onTouchTap={this.props.onLock}>
                                    <FontIcon className="fa fa-lock" style={{ fontSize: 20 }} />
                                </IconButton>
                            }
                            {lockPayrollPermission &&
                                (
                                    this.props.selectedPayrollHierarchies.filter((item) => item.LockedData.IsLocked).length > 0 ||
                                    (
                                        this.props.selectedPayrollHierarchies.length === 0 &&
                                        this.props.selectedEmployees.filter(emp =>
                                            this.props.payrollData.PayrollTimeHierarchies.find(hierarchy =>
                                                hierarchy.LockedData.LockedObjData.find(i => i.LockedObjId === emp.EmployeeId))
                                        ).length > 0
                                    )
                                ) &&
                                this.props.selectedPayrollHierarchies.filter(item => item.ClosedData.IsClosed).length === 0 &&
                                <IconButton data-intercom-target={"menu-Payroll-Btn-UnLockTimePayrollHierarchy"} tooltip={strings.Unlock} onTouchTap={this.props.onUnLock}>
                                    <FontIcon className="fa fa-unlock" style={{ fontSize: 20 }} />
                                </IconButton>
                            }
                            {AccountStore.getCurrentAccountSettings().FeatureSettings.EnableAccrualsTimeoff &&
                                closePayrollPermission &&
                                this.props.selectedPayrollHierarchies.length > 0 &&
                                this.props.selectedPayrollHierarchies.filter((item: IPayrollTimeHierarchy) => !item.ClosedData.IsClosed).length > 0 &&
                                <IconButton
                                    tooltip={strings.Close}
                                    onTouchTap={() => payrollHelper.getValidClosePayroll(this.props.payrollData.PayrollDates.EndDate, this.props.payrollData.PayGroupPaySettings) ?
                                        this.props.onClose() :
                                        AppStateStore.setProgressSnackbarContent(strings.Cannot_close_current_or_future_period)
                                    }
                                >
                                    <FlagCheckred color="rgb(97, 97, 97)" width={20} height={20} />
                                </IconButton>
                            }
                            <IconButton data-intercom-target={"menu-Payroll-Btn-DownloadPayrollFile"} tooltip={strings.DownloadPayrollFile} onTouchTap={this.props.onDownload}>
                                <FontIcon className="fa fa-download" style={{ fontSize: 20 }} />
                            </IconButton>
                            <IconButton data-intercom-target={"menu-Payroll-Btn-DownloadPayrollReport"} tooltip={strings.DownloadPayrollReport} onTouchTap={this.props.onDownloadTimeReport}>
                                <FontIcon className="fa fa-file-text" style={{ fontSize: 20 }} />
                            </IconButton>
                            {exportPayrollPermission &&
                                <IconButton data-intercom-target={"menu-Payroll-Btn-ExportPayrollFile"} tooltip={strings.ExportPayrollFile} onTouchTap={this.props.onExport}>
                                    <FontIcon className="fa fa-arrow-circle-right" style={{ fontSize: 20 }} />
                                </IconButton>
                            }
                        </div>
                    }
                </div>
                {
                    this.props.loading ?
                        <div style={{ textAlign: "center", marginTop: 30 }}>
                            <CircularProgress />
                        </div> :
                        <div style={{ textAlign: "center", marginTop: 20, overflow: "auto", paddingLeft: 5, paddingRight: 5 }}>
                            {payrollTimeHierarchies && payrollTimeHierarchies.length > 0 ?
                                <PayrollTimeByHierarchyTable
                                    ref={(elem) => this.PayrollTimeByHierarchyTable = elem}
                                    payrollDates={this.props.payrollData.PayrollDates}
                                    payrollTimeHierarchies={payrollTimeHierarchies}
                                    timeTotals={this.props.payrollData ? this.props.payrollData.HoursSummary.TimeTotals : null}
                                    showTimecardPopup={this.props.showTimecardPopup}
                                    handleSelectPayrollHierarchy={this.props.handleSelectPayrollHierarchy}
                                    handleSelectEmployee={this.props.handleSelectEmployee}
                                    reloadTimeCard={this.props.reloadTimeCard}
                                /> :
                                <div style={{ fontSize: 20, marginTop: 50, height: 22 }}>{strings.No_Payroll_Time_by_Hierarchy_Data}</div>
                            }
                        </div>
                }
            </div >
        )
        return AccountStore.getExpensesEnabled() &&
            !AccountStore.getExpenseIsPayrollTime() &&
            hasPermission(AuthenticationStore.Permissions.Expense.ViewPayrollExpense) ?
            <Paper zDepth={1} style={{ paddingTop: 0, paddingBottom: 20, paddingLeft: 10, paddingRight: 10, position: "relative" }}>
                {renderElem}
            </Paper> :
            renderElem
    }
}
